import { useAppSelector } from 'hooks/useAppSelector'
import { useProductsAndCategories } from 'hooks/useProductsAndCategories'
import React from 'react'
import { useAppDispatch } from 'reduxStore'
import {
  itemPayloadSelectors,
  selectDateAndTime,
  setTimeslotOrderlines,
} from 'reduxStore/ducks/storage/storageFlow'

import type { DateAndTime } from '../../api-client'
import { SelectDateAndTimeBase } from '../Common/SelectDateAndTimeBase'

const SelectDateAndTime = ({ onNextStep }: { onNextStep: () => void }) => {
  const { timeslot, date } = useAppSelector((state) => state.storageFlow.dateAndTime)
  const coupon = useAppSelector((state) => state.storageFlow.coupon)
  const orderType = useAppSelector((state) => state.storageFlow.orderType)
  const dispatch = useAppDispatch()
  const items = useAppSelector(itemPayloadSelectors.selectAll)
  const existingItems = useAppSelector((state) => state.storageFlow.existingItems)
  const { timeslotsProducts, isLoading } = useProductsAndCategories({ couponCode: coupon })

  const handleClickOnNextStep = (dateAndTime: DateAndTime) => {
    const { date, timeslot } = dateAndTime

    if (!isLoading && timeslot?.productId && timeslotsProducts) {
      dispatch(
        setTimeslotOrderlines([{ product: timeslotsProducts[timeslot.productId], quantity: 1 }])
      )
    } else {
      dispatch(setTimeslotOrderlines([]))
    }

    if (date && timeslot) {
      dispatch(selectDateAndTime({ timeslot, date }))
      onNextStep()
    }
  }

  return (
    <SelectDateAndTimeBase
      preSelectedDate={date}
      preSelectedTimeslot={timeslot}
      items={[...items, ...existingItems]}
      orderType={orderType}
      onNext={handleClickOnNextStep}
    />
  )
}

export { SelectDateAndTime }
